import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Planificás desde cero cada año',
    perdes: 'Horas del domingo que nunca recuperás'
  }, {
    sin: 'Sin fichas imprimibles',
    perdes: 'Clases donde tus alumnos no tienen material concreto'
  }, {
    sin: 'Sin actividades contextualizadas',
    perdes: 'Alumnos que no conectan la teoría con lo que viven'
  }, {
    sin: 'Sin experimentos guiados',
    perdes: 'Ferias de ciencias improvisadas que no impactan'
  }, {
    sin: 'Sin evaluaciones listas',
    perdes: 'Tiempo perdido creando instrumentos de evaluación'
  }, {
    sin: 'Sin proyectos EAI',
    perdes: 'Incumplimiento de la Ley 27.621 por falta de material'
  }, {
    sin: 'Sin material argentino',
    perdes: 'Ejemplos europeos que tus alumnos no pueden relacionar con nada'
  }, {
    sin: 'Sin planificación secuenciada',
    perdes: 'Unidades desarticuladas que no construyen aprendizaje real'
  }];
  return <section className="py-20 bg-[#0f1d35] text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="bg-[#0a1428]/60 rounded-2xl p-6 md:p-10 border border-[#1e3a5f] mb-12 max-w-3xl mx-auto" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-6 pb-4 border-b border-[#1e3a5f]" data-id="element-23">
            <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-24">
              Sin el Megapack
            </div>
            <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-25">
              Lo que realmente perdés
            </div>
          </div>
          <ul className="space-y-6" data-id="element-26">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-2 gap-4 items-center" data-id="element-27">
                <div className="flex items-start gap-3" data-id="element-28">
                  <div className="mt-1 bg-[#1e3a5f] p-1 rounded-full shrink-0 border border-[#2d4d75]" data-id="element-29">
                    <X className="w-4 h-4 text-slate-400" data-id="element-30" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base" data-id="element-31">
                    {row.sin}
                  </span>
                </div>
                <div className="text-red-300/90 text-sm md:text-base font-medium" data-id="element-32">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#0f1d35] to-[#1e3a5f] rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-400/30" data-id="element-33">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-34">
            🌩️🇦🇷 "La próxima vez que enseñes meteorología, podés hacerlo con
            material concreto, contextualizado y listo para usar. O podés seguir
            buscando en Google y armando todo desde cero."
          </p>
        </motion.div>
      </div>
    </section>;
}